import React from "react";

export default function DemandCourseGridSkeleton() {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md animate-pulse flex flex-col h-full">
      {/* Image skeleton */}
      <div className="h-[200px] bg-gray-200 relative">
        {/* Badge skeleton */}
        <div className="absolute top-3 right-3 h-7 w-28 bg-gray-300 rounded"></div>
      </div>
      
      {/* Content skeleton */}
      <div className="p-5 flex flex-col flex-grow">
        {/* Delivery mode */}
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
        
        {/* Title */}
        <div className="mb-3">
          <div className="h-6 bg-gray-200 rounded w-full mb-2"></div>
          <div className="h-6 bg-gray-200 rounded w-4/5"></div>
        </div>
        
        {/* Affiliations */}
        <div className="flex items-center gap-2 mb-3">
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="flex gap-2">
            <div className="h-[25px] w-[32px] bg-gray-200 rounded"></div>
            <div className="h-[25px] w-[32px] bg-gray-200 rounded"></div>
          </div>
        </div>
        
        {/* Stats */}
        <div className="flex gap-4 mb-4">
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-4 bg-gray-200 rounded w-28"></div>
        </div>
        
        {/* Price */}
        <div className="mb-4">
          <div className="h-4 bg-gray-200 rounded w-20 mb-1"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
        </div>
        
        {/* Buttons */}
        <div className="flex gap-3 mt-auto">
          <div className="h-10 bg-gray-200 rounded flex-1"></div>
          <div className="h-10 bg-gray-200 rounded flex-1"></div>
        </div>
      </div>
    </div>
  );
}